import type { IconProps } from '../types/IconProps.ts';
export const Rewind: IconProps = {
    name: 'Rewind',
    children: [
        `<path d="M12.73 13.41a1.8 1.8 0 0 1 0-2.78l6.85-5.6a1.5 1.5 0 0 1 2.45 1.15v11.67a1.5 1.5 0 0 1-2.45 1.16z" />`,
        `<path d="M2.45 13.21a1.5 1.5 0 0 1 0-2.32l7.13-5.83a1.5 1.5 0 0 1 2.45 1.16v11.67a1.5 1.5 0 0 1-2.45 1.16z" />`,
    ]
};